export default __webpack_public_path__ + "static/media/jph-logo.f491a601.svg";